import {
    Avatar, Backdrop, createTheme, Dialog, DialogContent,
    DialogContentText, DialogTitle, Grid, IconButton, List,
    ListItem, ListItemAvatar, ListItemText, MuiThemeProvider,
    TextField, Typography
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Add as AddIcon, Delete as DeleteIcon } from '@material-ui/icons';
import MUIDataTable from 'mui-datatables';
import { useSnackbar } from 'notistack';
import React, { useEffect, useRef, useState } from 'react';
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AlertDialog from '../../components/ui/AlertDialog';
import ButtonUI from '../../components/ui/ButtonUI';
import { useAuth } from '../../hooks/auth';
import { MvmInvoice } from '../../interfaces/Mvm';
import AsnApi from '../../services/AsnApi';
import getDefaultGridOptions from '../../utils/componentUtils';
import utilsDate from '../../utils/Date';
import { useStyles } from './Style';

type props =  any;

const ASNInvoiceList: React.FC<props> = ({ control, title, name, showItens, allowAdd, allowDelete, Mvm}) => {

    const classes = useStyles();
    const { t } = useTranslation("Mvm");
    const { t: _t } = useTranslation("General");
    const { t: it } = useTranslation("MvmInvoice");
    const { enqueueSnackbar } = useSnackbar();
    const { user } = useAuth();
    const [circularLoading, setCircularLoading] = useState(false);
    const [selectInvoiceType, setSelectInvoiceType] = useState(false);
    const [unknownTypeInvoice, setUnknownTypeInvoice] = useState<null | MvmInvoice>(null);
    const { fields: _fields, append, remove } = useFieldArray({ control, name: name });
    const fields = _fields as Record<string, any>[];
    const invoiceTypes = [ 'V', 'E', 'A', 'G', 'I', 'M', 'P', 'R'];
    const refFieldInvoiceKey = useRef<HTMLInputElement>(null)
    const [invoiceItems, setInvoiceItems] = useState<any>([])

    useEffect(() => {
        if (showItens) {
            var tempInvoiceItems = []
            for (var i = 0; i < fields.length; i++) {

                var invoiceKey = fields[i]["invoiceKey"]
                var invoiceNumber = fields[i]["invoiceNumber"]
                var invoiceDate = fields[i]["invoiceDate"]
                var invoiceType = fields[i]["invoiceType"]
                
                if(fields[i]["items"].length > 0){
                    var items = fields[i]["items"].map((element: { partnumberId: any; partnumberCode: any; itemQuantity: any; bonusNumber: any; bonusRegisteredQuantity: any; itemDescription: any; }) => ({ 
                        invoiceFieldPosition: i,  
                        invoiceKey: invoiceKey,
                        invoiceNumber: invoiceNumber,
                        invoiceDate: invoiceDate,
                        invoiceType: invoiceType,
                        partNumberCode: element.partnumberCode,
                        partNumberDescription: element.itemDescription,
                        itemQuantity: element.itemQuantity,

                    }))

                    for (var j = 0; j < items.length; j++) {
                        tempInvoiceItems.push(items[j])
                    }
                }
                else {
                    
                    tempInvoiceItems.push({ 
                        invoiceFieldPosition: i,  
                        invoiceKey: invoiceKey,
                        invoiceNumber: invoiceNumber,
                        invoiceDate: invoiceDate,
                        invoiceType: invoiceType,
                        partNumberCode: null,
                        partNumberDescription: null,
                        itemQuantity: null,
                    })
                }
            }

            setInvoiceItems(tempInvoiceItems)
        }

    }, [fields])

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''
                }
            }
        }
    })

    const columns = [
        {
            name: 'id',
            options: {
                display: false,
            }
        },
        {
            name: 'invoiceKey',
            label: String(t('invoiceKey')),
            options: {
                setCellProps: () => ({
                    align: "left",
                }),
            }
        },
        {
            name: 'invoiceNumber',
            label: String(t('invoiceNumber')),

            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })    
            }
        },
        {
            name: 'invoiceDate',
            label: String(t('invoiceDate')),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return utilsDate.DateShort(value);
                }
            }
        },
        {
            name: 'invoiceType',
            label: String(t('invoiceType')),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    //return it("invoiceType_" + value);
                    return (<span>Venda</span>);
                }
            }
        },
        {
            name: 'partNumberCode',
            label: String(t('partNumberCode')),
            options: {
                display: showItens,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })    
            }
        },
        {
            name: 'partNumberDescription',
            label: String(t('partNumberDescription')),
            options: {
                display: showItens,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })    
            }
        },
        {
            name: 'itemQuantity',
            label: String(t('itemQuantity')),
            options: {
                display: showItens,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })    
            }
        },
        {
            name: "",
            options: {
                setCellProps: () => ({
                    align: "right"
                }),
                disableClick: true,
                sort: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => (
                    renderButtons(tableMeta.rowData[0], tableMeta.rowIndex)
                )
            }
        },
    ]

    const renderButtons = (id: any, rowIndex: any) => {
        //Se usuario acabou de incluir esta nota na lista, ela tem mvmid=0
        let justAdded = false;//fields[rowIndex]['mvmId'] == 0;

        if ((allowAdd && justAdded) || allowDelete)
            return (
                <AlertDialog
                    dialogTitle={t("dialogDeleteTitle")}
                    dialogContentText={t("dialogDeleteContentText")}
                    cancelTextButton={t("cancelDeleteTextButton")}
                    confirmTextButton={t("confirmDeleteTextButton")}
                    confirmDialogFunction={() => removeMvmInvoiceFromList(rowIndex)}
                    Button={
                        <IconButton size='small' edge="end">
                            <DeleteIcon />
                        </IconButton>
                    }
                />
            );
        else
            return (<></>)
    }

   
    async function AddAsnInvoiceToList() {

        setCircularLoading(true);
        var invoiceKeySearch = refFieldInvoiceKey.current
        if (!invoiceKeySearch)
        {
            setCircularLoading(false);
            return
        }

        var invoiceKey = String(invoiceKeySearch.value)

        if (invoiceKey.length != 44) {
            enqueueSnackbar(t("invoiceKeyNot44CharValidation"), { variant: 'warning' })
            setCircularLoading(false);
            return
        }

        var existingInvoice = false
        fields.map((field) => {
            if ((field as any).invoiceKey === invoiceKey){
            existingInvoice = true
            }
        })

        if (existingInvoice) {
            enqueueSnackbar(t("mvmInvoiceOnList"), { variant: 'warning' })
            setCircularLoading(false)
            return
        }

        // var validInvoice = 
        // await AsnApi.validateInvoicesInUse(
        //     0,
        //     invoiceKey
        //   );

        var error = false;

          await AsnApi.validateInvoicesInUse(0,invoiceKey)
          .then(response => {
            if(response) {
                enqueueSnackbar(it("alradyAssocieatedInvoice"), { variant: 'warning' })
                error = true;
            }
          })
          .catch(response => {
            enqueueSnackbar(it("errorValidatingInvoice"), { variant: 'warning' })
            error = true;
          })
          .finally(() => { setCircularLoading(false); });
        

        if (error)
          return;

        addInvoiceToList({invoiceKey:invoiceKey, invoiceNumber:Number(invoiceKey.substring(25,34)), invoiceType: "V" })

        invoiceKeySearch.value = ""

        setCircularLoading(false)
    }

    const removeMvmInvoiceFromList = (index: number) => {
        remove(index)
    }

    //Adicionar nota fiscal na lista da grid:
    function addInvoiceToList(mvmInvoice:any) {
        
        mvmInvoice.id = 0; //garantir que id = 0 (nova NF inserida na lista): Se a nf veio do elog, pode ter vindo com o id_nota_Fiscal preenchido neste campo erroneamente
        append(mvmInvoice);
        enqueueSnackbar(t("mvmInvoiceAddSuccess"), { variant: 'success' });
    }

    //Usuario escolheu o tipo da nota fiscal:
    async function handleChooseInvoiceType(invoiceType: string) {
        let mvmInvoice = unknownTypeInvoice;

        if (invoiceType === 'cancel')
        {
            setSelectInvoiceType(false);
            setUnknownTypeInvoice(null);
            return;
        }

        //Preencher o tipo e incluir na lista
        if (mvmInvoice !== null)
        {
            mvmInvoice.invoiceType = invoiceType;
            addInvoiceToList(mvmInvoice);
            setSelectInvoiceType(false);
        }
    }

    return (
        <Grid style={{ marginTop: 20, width: "98%", marginLeft: 10, marginBottom: 10 }}>
            <Typography className={classes.root} style={{ marginLeft: 0 }} >
                {title ? title : t("invoices")}
            </Typography>

            {!allowAdd ? <Grid /> :
                <Grid container spacing={1} style={{ marginBottom: 10 }}>
                    <Grid item >
                        <TextField
                            label={t("invoiceKey")}
                            name="invoiceKeySearch"
                            type='text'
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    AddAsnInvoiceToList()
                                    refFieldInvoiceKey.current?.focus()
                                }
                            }}
                            onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0, 44) }}
                            style={{ width: 400 }}
                            inputRef={refFieldInvoiceKey} />
                    </Grid>

                    <Grid>
                        <ButtonUI
                            onClick={() => { AddAsnInvoiceToList(); refFieldInvoiceKey.current?.focus()} }
                            color="primary"
                            variant="contained"
                            style={{ maxWidth: '40px', maxHeight: '38px', minWidth: '40px', minHeight: '38px', marginTop: 15, marginLeft: '10px' }}>
                            <AddIcon />
                        </ButtonUI>
                    </Grid>
                </Grid>
            }

            <Backdrop style={{ zIndex: 9999 }} open={circularLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Typography className={classes.paper} style={{ marginLeft: 0 }} >
                {_t("totalRecords")} {fields ? fields.length : '0'}
            </Typography>
            <MuiThemeProvider theme={myTheme} >
                <MUIDataTable
                    title=""
                    data={showItens ? invoiceItems : fields}
                    columns={columns}
                    options={{
                        ...getDefaultGridOptions(_t),
                        serverSide: false,
                        pagination: false,
                        sort: false,
                        selectToolbarPlacement: "none",
                        filter: false,
                        search: false,
                        download: false,
                        print: false,
                        viewColumns: false,
                        selectableRows: 'none',
                    }}
                />
            </MuiThemeProvider>

            
            {/* Dialog de selecao do tipo da NF */ }
            <Dialog open={selectInvoiceType} scroll="body">
                <DialogTitle>{it("unknownInvoiceTypeTitle")}</DialogTitle>
                <DialogContent><DialogContentText>{it("unknownInvoiceTypeText")}</DialogContentText></DialogContent>
                <List>
                    <ListItem button key={'cancel'} onClick={() => handleChooseInvoiceType('cancel')}>
                        <ListItemAvatar>
                            <Avatar>
                            <DeleteIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText>{it("unknownInvoiceTypeCancel")}</ListItemText>
                    </ListItem>
                    {invoiceTypes.map((x) => {
                        return (
                            <ListItem button key={x} onClick={() => handleChooseInvoiceType(x)}>
                                <ListItemAvatar>
                                    <Avatar>
                                    <AddIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText>{it("invoiceType_" + x)}</ListItemText>
                            </ListItem>
                        );
                    })}
                </List>
            </Dialog>
        </Grid>
    )
}

export default ASNInvoiceList